
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refleksi-kompetensi/ineligible",
      function () {
        return require("private-next-pages/refleksi-kompetensi/ineligible.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refleksi-kompetensi/ineligible"])
      });
    }
  